import { useMutation } from '@apollo/client'

import { SendJoorPayImInterestedEmailDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  mutation SendJoorPayImInterestedEmail($input: SendJoorPayImInterestedEmailInput!) {
    sendJoorPayImInterestedEmail(input: $input) {
      success
    }
  }
`

export function useSendPaymentsInterestEmailMutation() {
  const [mutate, { loading }] = useMutation(
    SendJoorPayImInterestedEmailDocument,
    {
      client: atlasClient,
    },
  )
  return {
    sendPaymentsImInterestedEmail: (orderId: string) => {
      return mutate({
        variables: {
          input: {
            orderId,
          },
        },
      })
    },
    loading,
  }
}
